import { queryKeys } from 'src/services/api/constants';

export type LeadFactKey =
    | 'annual_income'
    | 'household_size'
    | 'pet_type'
    | 'voucher_type'
    | 'phone_number'
    | 'email';

export type LeadFactStatus = 'pending' | 'accepted' | 'rejected';

export type LeadFactSource = 'llm' | 'regex_rule';

export type LeadVoucherType = 'section_8' | 'vash' | 'other';

/** Voucher enum values in display order, with their human labels (editor dropdown
 * options and display formatting). `section_8` covers Housing Choice / Section 8 / HCV. */
export const VOUCHER_TYPE_OPTIONS: ReadonlyArray<{ value: LeadVoucherType; label: string }> = [
    { value: 'section_8', label: 'Section 8' },
    { value: 'vash', label: 'VASH' },
    { value: 'other', label: 'Other' },
];

/**
 * One suggestion-lifecycle row per (lead, key), addressed by its surrogate `id`.
 * The lead's own columns are the source of truth for fact values; accepting writes
 * `value` through to the column. A rejected row keeps its value so an identical
 * re-extraction is not re-suggested.
 */
export type ILeadFactSuggestion = {
    id: number;
    key: LeadFactKey;
    /** annual_income is always an ANNUAL amount; display derives monthly (÷12). */
    value: string;
    status: LeadFactStatus;
    source: LeadFactSource;
};

/** The suggestion row as it comes off the wire (backend field is `suggested_value`). */
export type LeadFactSuggestionWire = {
    id: number;
    key: LeadFactKey;
    suggested_value: string;
    status: LeadFactStatus;
    source: LeadFactSource;
};

export type ListSuggestionsWire = {
    suggestions: LeadFactSuggestionWire[];
};

export const fromWire = (row: LeadFactSuggestionWire): ILeadFactSuggestion => ({
    id: row.id,
    key: row.key,
    value: row.suggested_value,
    status: row.status,
    source: row.source,
});

export const getLeadFactsQueryKey = (leadUuid: string) => [queryKeys.leadFacts, leadUuid];
